import React from "react";
import { useNavigate } from "react-router-dom";
import LoginHeader from "../components/Login/LoginHeader";
import EmailForm from "../Registration/EmailForm";


const AccountRegistration = () => {
  const navigate = useNavigate();

  const navigateToLogIn = () => {
    navigate("/login");
  };

  return (
    <>
      <LoginHeader navigateToLogIn={navigateToLogIn} />
      <EmailForm />
    </>
  );
};

export default AccountRegistration;
